import { AssignUserSelector } from "@/components/assign-user-selector";
import {
  AssignedLocationsQueryKeys,
  type AssignedLocationsTableQueryParams,
  type LocationsTableQueryParams,
} from "@/components/table/views/screener-locations";
import { useFilterAnalytics } from "@/hooks/analytics.hooks";
import type { FilterParamsHandle } from "@/hooks/use-filter-params";
import type { UserListUser } from "@/types/user";
import { TestID } from "@/utils/helpers";

interface AssignedUserFilterProps {
  filters: FilterParamsHandle<
    LocationsTableQueryParams | AssignedLocationsTableQueryParams
  >;
  users: UserListUser[];
}

export const AssignedUserFilter = ({
  filters,
  users,
}: AssignedUserFilterProps) => {
  const trackFilter = useFilterAnalytics("Assigned to");

  return (
    <AssignUserSelector
      baseTestId={new TestID("screener-locations", "assigned-to-filter")}
      keyPrefix="assigned_to_filter"
      multi
      onChange={(value) => {
        trackFilter(value);
        filters.toggleValue(AssignedLocationsQueryKeys.assignedTo, value);
      }}
      usersOverride={users}
      value={filters.getAll(AssignedLocationsQueryKeys.assignedTo) ?? []}
    />
  );
};
